import { useState } from "react";

import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Heading,
  Stack,
  HStack,
  Text,
  useDisclosure,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
} from "@chakra-ui/react";

// import { useHistory, useParams } from "react-router-dom";

// import Arrow from "assets/svg/icons-new/arrow.svg";
import { ReactComponent as FilterIcon } from "assets/svg/filter.svg";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";

import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import FilterModal from "components/Modals/PartnersFilter";

import Button from "components/Button/Button";
import { CustomTab } from "../Cards/MyCard";

// import Select from "components/Select/Select";
// import Input from "components/Input/Input";
// import SuccessModal from "components/Modals/Success";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import AffiliateLeaderboardTopEarnersPanel from "./AffiliateLeaderboardTopEarners";
import AffiliateLeaderboardReferrerEarnersPanel from "./AffiliateLeaderboardReferrerEarners";
import Emitter from "libs/Emitter";

// import { useAffiliateLeaderboardMutation } from "services/walletApi";
// import take from "lodash/take";
// import isEmpty from "lodash/isEmpty";
// import orderBy from "lodash/orderBy";

// import HistoryItem from "components/AffiliateItems/HistoryItem";

// import constant from "config/constant";
// import toPrecision from "util/toPrecision";
// import toCoinLocale from "util/toCoinLocale";
// import { toQueryString } from "util/utils";

export default function AffiliateLeaderboard(props) {
  const [state, _setState] = useState({});

  const setState = (newState) => _setState(() => ({ ...state, ...newState }));

  const { isOpen, onOpen, onClose } = useDisclosure();

  //   const { userData } = props;

  //   const { id } = useParams();

  //   const toast = useToast();
  //   const loaded = useRef(false);
  //   const history = useHistory();
  // const { isOpen, onOpen, onClose } = useDisclosure();
  //   const [state, _setState] = useState({ type: "price" });

  //   const setState = (newState) => _setState(() => ({ ...state, ...newState }));

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />
      <Box as="section">
        <Box
          className="account-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 15vw)", "calc(100% - 35vw)"]}
            m="0"
            p={[0, 0, "1rem"]}
          >
            <Stack mx={["24px", 0]} mb={["24px", "32px"]}>
              <HStack w="100%" justifyContent="space-between">
                <Heading>Leaderboard</Heading>

                <Button onClick={onOpen}>
                  <HStack>
                    <Box boxSize="20px" as={FilterIcon} />
                    <Text>Filter</Text>
                  </HStack>
                </Button>
              </HStack>
              <Breadcrumb
                className="animate__animated animate__fadeInDown"
                separator={
                  <ArrowForwardIosRoundedIcon
                    style={{ fontSize: ".8em", color: "#6E7191" }}
                  />
                }
              >
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account">
                    Account
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account/partners">
                    Bitmama Partners
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to="">
                    Leaderboard
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Stack>

            <Box
              bg="white"
              p={["32px 24px", "32px 24px", "40px"]}
              //   mt={["24px", "10px"]}
              pb="80px"
              borderRadius={[0, "8px", "16px"]}
            >
              <Tabs w="100%" isFitted>
                <TabList border="none" borderRadius="6px" p="6px" bg="#D9DBE9">
                  <CustomTab>Top Earners</CustomTab>
                  <CustomTab>Referred Users</CustomTab>
                </TabList>

                <TabPanels>
                  <TabPanel px="0">
                    <AffiliateLeaderboardTopEarnersPanel filters={state} />
                  </TabPanel>
                  <TabPanel px="0">
                    <AffiliateLeaderboardReferrerEarnersPanel filters={state} />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          </Container>
        </Box>
      </Box>
      {/* <SuccessModal
        isOpen={isOpen}
        onClose={handleClose}
        title="Success"
        message={`Price alert successfully updated `}
      /> */}
      <FilterModal
        isOpen={isOpen}
        onClose={onClose}
        onFilter={(filter) => {
          setState({ ...filter });
          Emitter.emit("PARTNERS_LEADERBOARD_DATE_FILTER", filter);
        }}
      />
    </Box>
  );
}
